import React, { useRef, useEffect } from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import SectionList from './SectionList';
import { GAME_SYSTEM_OPTIONS } from '../../../gameSystems/registry';

const TemplateBuilder = ({ template, setTemplate }) => {
	const nameRef = useRef();
	const versionRef = useRef();
	const gameSystemRef = useRef();

	// Update refs when template changes
	useEffect(() => {
		if (nameRef.current) nameRef.current.value = template.name || '';
		if (versionRef.current) versionRef.current.value = template.version || '';
		if (gameSystemRef.current) gameSystemRef.current.value = template.gameSystem || '';
	}, [template]);

	// On blur, update the template
	const updateField = () => {
		setTemplate({
			...template,
			name: nameRef.current.value,
			version: versionRef.current.value,
			gameSystem: gameSystemRef.current.value,
		});
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextField
					label="Template Name"
					variant="outlined"
					defaultValue={template.name}
					inputRef={nameRef}
					onBlur={updateField}
					fullWidth
				/>
			</Grid>
			<Grid item xs={12}>
				<TextField
					label="Template Version"
					variant="outlined"
					defaultValue={template.version}
					inputRef={versionRef}
					onBlur={updateField}
					fullWidth
				/>
			</Grid>
			<Grid item xs={12}>
				<TextField
					label="Game System"
					variant="outlined"
					defaultValue={template.gameSystem}
					inputRef={gameSystemRef}
					select
					onChange={updateField}
					onBlur={updateField}
					fullWidth
				>
					{GAME_SYSTEM_OPTIONS.map((option) => (
						<MenuItem key={option.id} value={option.name}>
							{option.name}
						</MenuItem>
					))}
				</TextField>
			</Grid>
			<Grid item xs={12}>
				<SectionList template={template} setTemplate={setTemplate} />
			</Grid>
		</Grid>
	);
};

export default TemplateBuilder;
